import React, { useState, useEffect } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { NavLink } from "react-router-dom";
import { updateProfile } from "../../Redux/actions/user";
import LoadProfile from "../../UtilityComponents/loadProfile";
import processIcon from "../../Assets/iconbusinessprocesses.png";
import processIconActive from "../../Assets/iconbusinessprocessesactive.png";
import vaultIcon from "../../Assets/iconsecretsvault.png";
import vaultIconActive from "../../Assets/iconsecretsvaultactive.png";
import schedulesIcon from "../../Assets/iconschedules.png";
import schedulesIconActive from "../../Assets/iconschedulesactive.png";
import robotIcon from "../../Assets/iconrobot.png";
import DashboardActive from "../../Assets/dashboardActive.svg";
import Dashboard from "../../Assets/dashboard.svg";
import robotIconActive from "../../Assets/iconrobotactive.png";
import workerlistIcon from "../../Assets/iconmanualtasks.png";
import workerlistIconActive from "../../Assets/iconmanualtasksactive.png";
import group from "../../Assets/group1.png";
import keycloak from '../../keycloak';
import "./sidenav.css";

function SideNav(props) {

  let user = props.user;
  let { data } = props.organizations;

  const [context, setContext] = useState("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prevState) => !prevState);

  useEffect(() => {
    if (user.organization_id && data.length > 0) {      
      let org = data.find((obj) => obj.id.toString() === user.organization_id);      
      setContext(org.display_name);
    } else {
      setContext(user.name ? user.name : user.email);
    }
  }, [data, user]);

  const handleOrgs = async (e, org) => {
    e.preventDefault();
    let values = {};
    if (org) {
      values = { ...user, organization_id: org.id, role_id: org.role_id };
      setContext(org.display_name);
    } else {
      delete user["organization_id"];
      values = { ...user };
      setContext(user.name ? user.name : user.email);
    }
    let data = await updateProfile({ ...values }, user);
    if (data && data.status === 204) {
      keycloak.login();
    }
  };
  
  let name=user.given_name && user.family_name?user.given_name.charAt(0).toUpperCase() + 
  user.family_name.charAt(0).toUpperCase():""

  return (
    <div className="side-nav">
      <div className="profile-container ">
      {user.profilePic || name.length === 0 ?                      
        <LoadProfile {...props.user} />:<div className="Profileicon">{name}</div>
      }
        <div className="profile-info">
          {data.length > 0 ? (
            <Dropdown isOpen={dropdownOpen} toggle={toggle}>
              <DropdownToggle
                caret
                className="context-btn"
                style={{ width: "209px" }}
              >
                <div className="user-name">
                  <div className="singlechar">{context}</div>
                </div>
              </DropdownToggle>
              <DropdownMenu center="true">
                <DropdownItem header>Switch Dashboard context</DropdownItem>
                {user.organization_id ? (
                  <DropdownItem onClick={(e) => handleOrgs(e)}>
                    {user.name ? user.name : user.email}
                  </DropdownItem>
                ) : null}
                {data.map((obj, ind) => {                  
                  return (
                    <DropdownItem
                      onClick={(e, org) => handleOrgs(e, obj)}
                      key={ind}
                    >
                      {obj.display_name === context ? (
                        <i className="fas fa-check-circle"></i>
                      ) : null}
                      {obj.display_name}
                    </DropdownItem>
                  );
                })}
                <DropdownItem divider />
                <DropdownItem
                  onClick={() => props.history.push("/settings/organizations")}
                >
                  Manage Organizations
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          ) : (
            <label className="user-name">
              <div>{context}</div>
            </label>
          )}
        </div>
      </div>
      <div className="links-container">
        <ul>
          {/* <li
            className={
              window.location.pathname.includes("/eworkers")
                ? "link-container active-link "
                : "link-container"
            }
          >
            <NavLink to="/eworkers">
              <img
                src={
                  window.location.pathname.includes("/eworkers")
                    ? processIconActive
                    : processIcon
                }
                alt="process icon"
              ></img>
              E-Workers
            </NavLink>
          </li> */}
          <li
            className={
              window.location.pathname.includes("/dashboard")
                ? "link-container active-link "
                : "link-container"
            }
          >
            <NavLink to="/dashboard">
              <img
                src={
                  window.location.pathname.includes("/dashboard")
                    ? DashboardActive
                    : Dashboard
                }
                alt="dashboard icon"
              ></img>
              Dashboard
            </NavLink>
          </li>
          <li
            className={
              window.location.pathname.includes("/processes")
                ? "link-container active-link "
                : "link-container"
            }
          >
            <NavLink to="/processes">
              <img
                src={
                  window.location.pathname.includes("/processes")
                    ? processIconActive
                    : processIcon
                }
                alt="process icon"
              ></img>
              Action Flows
            </NavLink>
          </li>
          {/* <li
            className={
              window.location.pathname.includes("/documents")
                ? "link-container active-link "
                : "link-container"
            }
          >
            <NavLink to="/documents">
              <img
                src={
                  window.location.pathname.includes("/documents")
                    ? processIconActive
                    : processIcon
                }
                alt="process icon"
              ></img>
              Document Flows
            </NavLink>
          </li>
          <li
            className={
              window.location.pathname.includes("/conversations")
                ? "link-container active-link "
                : "link-container"
            }
          >
            <NavLink to="/conversations">
              <img
                src={
                  window.location.pathname.includes("/conversations")
                    ? processIconActive
                    : processIcon
                }
                alt="process icon"
              ></img>
              Conversation Flows
            </NavLink>
          </li> */}

          {/* <li
              className={
                window.location.pathname.includes("/settings/billing")
                  ? "link-container active-link "
                  : "link-container"
              }
            >
              <NavLink to="/settings/billing">
                <img
                  src={
                    window.location.pathname.includes("/settings/billing")
                      ? billingIconActive
                      : billingIcon
                  }
                  alt="process icon"
                ></img>
                Payments
              </NavLink>
            </li> */}
          <li
            className={
              window.location.pathname.includes("/workers")
                ? "link-container active-link "
                : "link-container"
            }
          >
            <NavLink to="/workers">
              <img
                src={
                  window.location.pathname.includes("/workers")
                    ? robotIconActive
                    : robotIcon
                }
                alt="process icon"
              ></img>
              E-Worker Machines
            </NavLink>
          </li>
          <li
            className={
              window.location.pathname.includes("/queues")
                ? "link-container active-link "
                : "link-container"
            }
          >
            <NavLink to="/queues">
              <img
                src={
                  window.location.pathname.includes("/queues")
                    ? workerlistIconActive
                    : workerlistIcon
                }
                alt="process icon"
              ></img>
              Queues
            </NavLink>
          </li>
          <li
            className={
              window.location.pathname.includes("/schedules")
                ? "link-container active-link "
                : "link-container"
            }
          >
            <NavLink to="/schedules">
              <img
                src={
                  window.location.pathname.includes("/schedules")
                    ? schedulesIconActive
                    : schedulesIcon
                }
                alt="process icon"
              ></img>
              Schedules
            </NavLink>
          </li>
          <li
            className={
              window.location.pathname.includes("/vault")
                ? "link-container active-link "
                : "link-container"
            }
          >
            <NavLink to="/vault">
              <img
                src={
                  window.location.pathname.includes("/vault")
                    ? vaultIconActive
                    : vaultIcon
                }
                alt="process icon"
              ></img>
              Secret Vault
            </NavLink>
          </li>
        </ul>
      </div>
      <div className="bottom-container">
        <img src={group} alt="group.png"></img>
      </div>
    </div>
  );
}

export default SideNav;
